/**
 * Duplicated from packages/fruitils/src/common.ts — keep in sync when changing article logic.
 *
 * money-map-simulator ships a Node build (dist/index.server.*) consumed by llm-service/mastra.
 * @fruitful/fruitils is TS-source-only (package.json main points at index.ts), so adding it as a
 * dependency makes Node try to execute packages/fruitils/*.ts at runtime ("Unknown file extension
 * .ts"). Metro/Expo apps can import fruitils directly; this package cannot.
 */
const ARTICLE_SKIP_PREFIXES = [
    'a ',
    'an ',
    'the ',
    'my ',
    'your ',
    'our ',
    'their ',
];

/** Descriptions that are mass nouns, plurals, or gerunds and shouldn't get "a/an". */
const NO_ARTICLE_WORDS = new Set([
    'travel',
    'gifts',
    'education',
    'moving',
    'home repairs',
    'charitable giving',
    'growing a family',
]);

const needsArticle = (name: string): boolean => {
    const lower = name.toLowerCase();
    if (NO_ARTICLE_WORDS.has(lower)) return false;
    return !ARTICLE_SKIP_PREFIXES.some((prefix) => lower.startsWith(prefix));
};

export const withArticle = (name: string): string => {
    const lower = name.charAt(0).toLowerCase() + name.slice(1);
    return needsArticle(lower) ? `a ${lower}` : lower;
};

/**
 * Member-facing savings goal label for rule cards / waterfall rows.
 * Descriptions are stored as noun phrases ("a trip", "wedding"); the UI
 * should read "Save for a trip" / "Save for a wedding".
 */
export const formatSaveForGoalLabel = (
    description: string | null | undefined,
): string => {
    const rawName =
        description != null && description.trim() !== ''
            ? description.trim()
            : 'savings goal';
    const lower = rawName.toLowerCase();
    if (lower.startsWith('save for ')) {
        return `Save for ${rawName.slice('save for '.length).trimStart()}`;
    }
    if (lower.startsWith('saving for ')) {
        return `Save for ${rawName.slice('saving for '.length).trimStart()}`;
    }
    return `Save for ${withArticle(rawName)}`;
};
